import AccommodationFilterSkeleton from "components/common/Skeleton/park/filter/AccommodationFilterSkeleton";
import { initialFilterParks, raInitialFilterParks } from "Data/parks";
import { useMasterContext } from "provider/MasterProvider";
import { useMetaContext } from "provider/MetaProvider";
import { useParksContext } from "provider/ParksProvider";
import React, { useState } from "react";
import Select from 'react-select';

const AnimalsParkMobileFilter = ({ onCancel }) => {
  const { metaLoading, accommodation } = useMetaContext();
  const { bonusExperience, parksSortBy, masterLoading } = useMasterContext();
  const { raFilters, parksDispatch } = useParksContext();

  const updateFilter = (name, value) => {
    parksDispatch({ type: "SET_RA_PAGE_INDEX", payload: 1 });
    parksDispatch({
      type: "UPDATE_RA_PARKS_FILTER",
      payload: { [name]: value },
    });
  };

  const clearFilter = (name, value) => {
    parksDispatch({
      type: "UPDATE_RA_PARKS_FILTER",
      payload: raInitialFilterParks,
    });
  };

  return (
    <>
      <div className="filterPhone d-lg-none">
        <div className="top_filterwrap d-flex align-items-center justify-content-between">
          <div className="title_top">
            <h4 className="mb-0">Select Filters</h4>
          </div>
          <div className="apply-btn d-flex gap-2">
            <button className="btn_apply" onClick={clearFilter} style={{ background: '#a0a7a5', color: '#fff' }}>Clear</button>
            <button className="btn_apply" onClick={onCancel} style={{ background: '#09422d', color: '#fff' }}>Cancel</button>
            <button className="btn_apply" onClick={onCancel}>Apply</button>
          </div>
        </div>
        <div className="searchwrap mb-3 mt-5 pt-3">
          <div className="row align-items-center">
            <div className="col-5">
              <div className="title_filter">
                <h6 className="mb-0">Sort By</h6>
              </div>
            </div>
            <div className="col-7">

              <Select
                id="packagesearch-custom_sort_by"
                classNamePrefix="custom_sort_by_input"
                value={
                  parksSortBy?.find(option => Number(option.value) === Number(raFilters?.custom_sort_by)) || null
                }
                onChange={(selectedOption) =>
                  updateFilter('custom_sort_by', selectedOption?.value || '')
                }
                options={parksSortBy || []}
                isSearchable
                isClearable
                isDisabled={masterLoading}
                placeholder={masterLoading ? "Loading..." : "Select Sort Option"}
                components={{ IndicatorSeparator: () => null }}
              />
            </div>
          </div>
        </div>
        <div className="searchwrap mb-3 mt-5">
          <div className="row align-items-center mt-2">
            <div className="col-5">
              <div className="title_filter">
                <h6 className="mb-0">Accommodation</h6>
              </div>
            </div>
            <div className="col-7">
              <div className="input_check ">
                {(Array.isArray(accommodation) && accommodation?.length > 0) ? (
                  accommodation?.map(accomo => (
                    <div className="d-flex align-items-center pt-1" key={accomo.value}>
                      <input
                        id={`accomodation-${accomo.value}`}
                        type="checkbox"
                        className="type checkbox_design me-3"
                        name="accomodation_id"
                        value={accomo.value}
                        checked={Array.isArray(raFilters?.accomodation_id) && raFilters.accomodation_id.includes(accomo.value)}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          const current = raFilters?.accomodation_id || [];
                          const newValues = checked
                            ? [...current, accomo.value]
                            : current.filter(v => v !== accomo.value);
                          updateFilter("accomodation_id", newValues);
                        }}
                      />
                      <label htmlFor={`accomodation-${accomo.value}`}>{accomo.label}</label>
                    </div>
                  )))
                  : metaLoading ? (
                    <AccommodationFilterSkeleton count={3} />
                  )
                    : (
                      <p>No Filter available</p>
                    )}
              </div>
            </div>
          </div>
        </div>

        <div className="searchwrap mb-3">
          <div className="row align-items-center">
            <div className="col-5">
              <div className="title_filter">
                <h6>Bonus Experience</h6>
              </div>
            </div>
            <div className="col-7">
              <div className="input_check ">
                {(Array.isArray(bonusExperience) && bonusExperience?.length > 0) ? (
                  bonusExperience.map(bonusExp => (
                    <div className="d-flex align-items-center pt-1" key={bonusExp.value}>
                      <input
                        id={`bonus-${bonusExp.value}`}
                        type="checkbox"
                        className="type checkbox_design me-3"
                        name="bonus_experience_id"
                        value={bonusExp.value}
                        checked={Array.isArray(raFilters?.bonus_experience_id) && raFilters.bonus_experience_id.includes(bonusExp.value)}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          const current = raFilters?.bonus_experience_id || [];
                          const newValues = checked
                            ? [...current, bonusExp.value]
                            : current.filter(v => v !== bonusExp.value);
                          updateFilter("bonus_experience_id", newValues);
                        }}
                      />
                      <label htmlFor={`bonus-${bonusExp.value}`}>{bonusExp.label}</label>
                    </div>
                  ))) : metaLoading ? (
                    <AccommodationFilterSkeleton count={4} />
                  )
                  : (
                    <p>No Filter available</p>
                  )}
              </div>
            </div>
          </div>
        </div>


      </div>
    </>
  );
};

export default AnimalsParkMobileFilter;
